import type { AnnouncementCar } from '@autobid/ui/types/Car'
import type { ItemDeleteEvent } from '@autobid/ui/types/websocket/ItemDeleteEvent'
import type { ItemWithdrawEvent } from '@autobid/ui/types/websocket/ItemWithdrawEvent'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  announcementCarQueryKey,
} from '@autobid/ui/composables/car/data/useCurrentCarAnnouncement'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useCurrentCarAnnouncementItemWithdrawOrDelete() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemWithdrawOrDelete = () => {
    const invalidateCurrentCar = (
      event: ItemWithdrawEvent | ItemDeleteEvent,
    ) => {
      const { auctionId, itemId } = event.context
      const currentCarKey = announcementCarQueryKey.byAuctionId(auctionId)
      const currentData = queryClient.getQueryData(
        currentCarKey,
      ) as AnnouncementCar | undefined

      if (!currentData) {
        return
      }

      const isItCurrentCar = currentData.id === itemId
      if (isItCurrentCar) {
        return queryClient.invalidateQueries(currentCarKey)
      }
    }

    const callback = (event: ItemWithdrawEvent | ItemDeleteEvent) => {
      randomDebounce(0, 2000, () => {
        invalidateCurrentCar(event)
      })
    }

    startListen({
      eventName: 'premium.ITEM_WITHDRAW',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: event => callback(event),
    })

    startListen({
      eventName: 'premium.ITEM_DELETED',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: event => callback(event),
    })
  }

  return { itemWithdrawOrDelete }
}
